import gql from 'graphql-tag'

export const GET_CURRENT_USER = gql`
  query {
    me {
      id
      name
      email
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/auth/current_user.js